import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { SetupService } from 'src/app/features/setup/services/setup.service';
import { LandingService } from 'src/app/core/services/landing.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-top-right-nav-menu',
  templateUrl: './top-right-nav-menu.component.html',
  styleUrls: ['./top-right-nav-menu.component.scss']
})
export class TopRightNavMenuComponent implements OnInit {
  selectedType: any;
  isTreeupdated: boolean;
  champSession: any;
  constructor(private router: Router,
    private layoutService: LayoutService,
    private landingService: LandingService,
    public session: StorageService,
    private notifier: NotificationService,
    private service: SetupService
  ) {
    this.champSession = session;
    this.isTreeupdated = layoutService.isTreeUpdated;
    layoutService.treeValueChange.subscribe(value => {
      this.selectedType = this.session.selectedType;
    });
  }
  content;
  commonContent;
  toggleTree = false;
  loadTree() {
    this.toggleTree = !this.toggleTree;
  }
  ngOnInit(): void {
    if (!this.session.loggednUser) {
      //if (!this.session.userId) {

      this.layoutService.getLoginInfo(this.session.userId).subscribe((resUser) => {
        this.session.loggednUser = resUser;
        this.setAccountDetails();
        this.GetUserList();
      });
    }
    else {
      this.selectedType = this.session.selectedType;
      this.setAccountDetails();
      this.GetUserList();
    }
  }
  showPopup() {
    this.commonContent = this.session.resource?.commonContent;
    this.content = this.session.resource?.topRightNavMenu;
    
  }
  funcLangPopup(lang) {
    this.session.language = lang;
    sessionStorage.removeItem('content');
    this.setResource();
    
    //this.router.navigateByUrl(this.router.url + '/?time=2121212221' );
  }

  setResource() {
    this.layoutService.getResource(this.session.language).subscribe(
      res1 => {
        //console.log(res1);
        this.session.resource = res1;
        window.location.reload();
      },
      (err) => {
        console.log(err.message);
      }
    );
  }
  /// BELOW IS THE FIRST FUNCTION TO BE CALLED for detected language of the user
  setAccountDetails(): void {
    if (!this.session.resource)
      this.setResource();

    this.layoutService.getAccountDetails(this.session.userId)
      .subscribe((response) => {
        // console.log('account details got are: ', response);
        if (response === null) {
          this.notifier.showError(this.session.resource?.tenantTree.select);
          //console.log('this.session.selectedType', this.session.selectedType);
        }
        else {
          let res = response;
          this.session.selectedType = {
            type: res.baselineSimulationType,
            typeId: res.typeId,
            tenantId: res.tenantId,
            userEmail: (this.session.userEmail) ? this.session.userEmail : '',
            userName: (this.session.userEmail) ? this.session.userEmail : '',
            userId: this.session.userId,
            simulationId: res.simulationId,
            simulationName: res.simulationName,
            simulationYear: res.simulationYear,
            baselineId: res.baselineId,
            baselineName: res.baselineName,
            baselineYear: res.baselineYear,
            isReadOnly: res.isReadOnly,
            currency: res.baselineCurrency,
            precision: res.baselinePrecision,
            isLocked: res.isLocked
          };
          //console.log("Retrieved Value is: ", this.session.selectedType);
          this.selectedType = this.session.selectedType;
        }
      });
    //console.log('The Value: ', this.session.selectedType);
  }

  userList;
  GetUserList() {

    this.service.GetUserList().subscribe((res) => {
      this.userList = res;
    });
  }

  selectUser(evt): void {
    this.session.userId = evt.target.options[evt.target.options.selectedIndex].text;//evt.target.value;
    this.session.userEmail = evt.target.options[evt.target.options.selectedIndex].text;
    this.layoutService.getLoginInfo(this.session.userId).subscribe((resUser) => {
      this.session.loggednUser = resUser;
      this.getTypeCount();
      this.setAccountDetails();
    });

  }

  getTypeCount() {
    if (this.session.userId && this.session.selectedType) {
      this.landingService.getSimulationCount(this.session.userId, this.session.tenantId, 0, 0)
        .subscribe((res) => {
          this.session.totalSimulation = res.simulationCount;
        });
      this.landingService.getBaseLineCount(this.session.userId, this.session.tenantId, 0)
        .subscribe((res) => {
          this.session.totalBaseLine = res.baseLineCount;
        });
    }
  }

  logout() {
    sessionStorage.removeItem(btoa('userId'));
    sessionStorage.removeItem(btoa('SELECTED_TYPE'));
    sessionStorage.removeItem(btoa('userEmail'));
    sessionStorage.removeItem(btoa('loggednUser'));
  }
}